module.exports = __webpack_public_path__ + "static/img/fyBotIcon.da825c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fyImg/fyBotIcon.png
// module id = m3xX
// module chunks = 3